import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useEffect, useState } from "react";
import VendorListNavigation from "@components/Vendors/vendorlist-navigation";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import {
  clientGetLocation,
  clientUpAttachedLocation,
} from "@services/location.service";
import { getValue } from "@utils/lodash";
import moment from "moment";
import DeleteModal from "@_common/deleteModal";
import {
  clientAttachLocationToVendor,
  clientDeleteAttachedLocationToVendor,
  clientGetAttachedLocationToVendor,
} from "@services/vendors.service";
import { toast } from "react-toastify";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import PaginationPage from "@components/pagination/pagination";
import SearchableDropdown from "@_common/SearchableDropdown";
import NoAccessPage from "@components/common/NoAccess";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import { NavLink } from "react-router-dom";


interface IGroupsProps {}

const VendorsLocations: React.FunctionComponent<IGroupsProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let params = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<any>("");
  const [attachedList, setAttachedList] = useState([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    getLocationData();
    getList();
    handleTriggerAPI(params.search_text);
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      getList();
      handleTriggerAPI(params.search_text);
    }
  }, [window.location.href, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getList = async () => {
    try {
      setIsLoading(true);
      let payload = {
        is_active: true,
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        // status: "active",
        sort_by: params.sort_by,
      };
      let queryRequest = QueryRequestHelper(payload);

      let resp = await clientGetAttachedLocationToVendor(
        params.id,
        queryRequest
      );
      if (resp) {
        setIsLoading(false);
        setAttachedList(getValue(resp, `data.locactions`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(true);
    }
  };
  const getLocationData = async () => {
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: 1,
      page_size: 10,
      // search_text: params.search_text,
      // // status: "active",
      // sort_by: params.sort_by,
      is_active: true,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        setIsLoading(false);
        let filtered = getValue(
          resp,
          `data.locations`,
          []
        ).filter((item: object) => getValue(item, `is_active`, false));

        setList(
          getValue(filtered, `length`, 0) > 0 &&
            filtered.map((item: object) => (
              {
              ...item,
              created_at: moment(getValue(item, `created_at`, "")).format(
                "DD MMM YYYY"
              ),
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
              value: getValue(item, `location_name`, ""),
              label: getValue(item, `location_name`, ""),              
            }))
        );
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleAdd = async (value: object) => {
    setSelectedLocation(value);
    try {
      let resp = await clientAttachLocationToVendor(params.id, {
        location_id: getValue(value, `id`, ""),
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedLocation("");
        getList();
        setSelectedValue({})
        handleTriggerAPI(params.search_text);
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await clientDeleteAttachedLocationToVendor(params.id, {
        location_id: deleteId,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getList();
        handleTriggerAPI(params.search_text);
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */

  const [selectedValue, setSelectedValue] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerAPI = async (value: string) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      is_active: true,
      search_text: value,
    };
    setSearchLoading(true);
    let queryRequest = QueryRequestHelper(payload);
    try {
    //   let resp = await clientGetLocation(queryRequest);
	let resp = await clientUpAttachedLocation(
        getValue(params, `id`, ""),
        queryRequest
      );
      if (resp) {
        setList(
          getValue(resp, `data.locations`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),

          }))
        );
        setSelectedValue({});
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const handleClick = (e: any) => {
    setSelectedValue(e);
    handleAdd(e);
    // handleSelectLocation(e);
  };

  /* ---------------------Column Section------------------------------*/
    const columns = React.useMemo(
      () => [
        
        {
          Header: () => (
            <div>
              Site <br /> <small className="text-muted">Site ID</small>
            </div>
          ),   
          accessor: "location_name",
          width: 150,
          Cell: ({ row }: any) => {
            return (
              <div>
                <NavLink to={`/location/detail/${getValue(row,`original.id`,"")}`}>
                  <b>{getValue(row,`original.location_name`,"")}</b>
								</NavLink>
                <div>{getValue(row,`original.location_id`,"")}</div>
              </div>
            );
          },    
        },
        
        {
          Header: () => (
            <div>
              Entity Name <br /> <small className="text-muted">City</small>
            </div>
          ),   
          accessor: "entity_name",
          width: 150,
          Cell: ({ row }: any) => {
            return (
              <div>
                <div><b>{getValue(row,`original.entity_name`,"")}</b></div>
                <div>{getValue(row,`original.state.name`,"")}</div>
              </div>
            );
          },    
        },
        {
          Header: () => (
            <div>
              Site Code
            </div>
          ),   
          accessor: "location_code",
          width: 100,
          Cell: ({ row }: any) => {
            return (
              <div>
                <div>{getValue(row,`original.location_code`,"")}</div>
              </div>
            );
          },    
        },
        {
          Header: "Status",
          accessor: "is_active",
          width: 150,
          Cell: ({ value }: { value: boolean }) => { // Explicitly type 'value' as boolean
            return value ? "Active" : "Inactive";
          },
        },
          {
            Header: "Action",
            width: 90,
            Cell: ({ row }: any) => {
              return (
                <div className="d-flex align-items-center justify-content-center">
                  <img
                    onClick={() =>
                      handleDeleteFun(
                        getValue(row, `original.id`, ""),
                        getValue(row, `original.location_name`, "")
                      )
                    }
                    src="/images/list-management/country/delete-icon.svg"
                    className="img-fluid"
                    style={{ height: "24px", width: "24px" }}
                  />
                </div>
              );
            },
          },
      ],
      []
    );

    const [selectedIDs, setSelectedIDs] = useState<any>([]);
    const getTableState = (value: object) => {
      let selectedIndexList = Object.keys(
        getValue(value, `selectedRowIds`, {})
      ).map((item) => parseInt(item));
      let selectedIds =
        attachedList.length > 0
          ? attachedList.filter((_item: object, index: number) =>
              selectedIndexList.includes(index)
            )
          : [];
      if (selectedIds.length > 0) {
        setSelectedIDs(
          selectedIds.map((item: object) => getValue(item, `id`, ""))
        );
      } else {
        setSelectedIDs([]);
      }
    };
    const rowClick = (obj: object) => {

    };
    const [check, setCheck] = useState(false);
    const handleRemoveNavItems = () => {
      setCheck(!check);
      setSelectedIDs([]);
    };
    const getTrProps = (rowInfo: any) => {
      if (getValue(rowInfo, `id`, "")) {
        return {
          // style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
        };
      }
      return {};
    };

  return (
    <Layout>
      <VendorListNavigation id={params.id} parentId={params.parentId} />
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "configuration_vendor"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="map-vendor-wrapper map-vendor-wrapper--vendor w-100 pt-5">
            {getValue(props, `permissions`, []).includes("update") && (
              <div className="map-vendor__details d-flex align-items-flex-start p-0">
                <div className="map-vendor__search map-vendor__search--vendor">
                  <div
                    className="map-vendor__search-form mb-3 position-relative"
                    style={{ width: "500px" }}
                  >
                    {/* <img
									src="/images/search.svg"
									className="img-fluid map-vendor__search-icon map-vendor__search-icon--vendor position-absolute"
								/> */}
                    {/* <Select
									placeholder="Select"
									options={list}
									onChange={(e: any) => handleAdd(e)}
									value={selectedLocation}
									className="custom-select"
								/> */}

                    <SearchableDropdown
                      placeholder={"Search Site"}
                      options={list}
                      searchLoading={searchLoading}
                      handleChange={(val: any) => handleTriggerAPI(val)}
                      handleClick={handleClick}
                      value={selectedValue}
                      label="label"
                      id="id"
                      className="custom"
                    />
                  </div>
                </div>
                {/* <div className='add-button'>
                      <button className='add-button'>Add</button>
                    </div> */}
              </div>
            )}
            <h5 className="map-vendor__search-title">Assigned Site</h5>
            {isLoading ? (
              <Loader />
            ) : getValue(attachedList, `length`, 0) > 0 ? (
              <>
                {/* {attachedList.map((item: object) => {
                  return (
                    <ul className="map-vendor__assign-list mt-2">
                      <li className="map-vendor__assign-list">
                        {getValue(item, `location_name`, "location_name")}
                      </li>

                      <li
                        className="map-vendor__assign-list"
                        onClick={() =>
                          handleDeleteFun(
                            getValue(item, `id`, ""),
                            getValue(item, `location_name`, "")
                          )
                        }
                      >
                        {getValue(props, `permissions`, []).includes(
                          "delete"
                        ) && (
                          <img
                            src="/images/close-black.svg"
                            className="img-fluid cursor-pointer"
                          />
                        )}
                      </li>
                    </ul>
                  );
                })} */}
                  <div className="vendor-location-mapping-table">
                    <ScrollableDataTable
                      columns={columns}
                      data={attachedList}
                      checkboxlogo
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                    />
                  </div>
              </>
            ) : (
              <>
                {Object.keys(urlParams).length !== 0 ? (
                  <>
                    <Notfound />
                  </>
                ) : (
                  <Notfound />
                )}
              </>
            )}
            {/* <div className="position-absolute map-vendor__footer-image w-100">
					<img
						src="/images/footer-image.svg"
						className="img-fluid footer-image"
					/>
				</div> */}
            {/* <div className="footer-wrapper d-flex justify-content-between mt-3">
              {getValue(attachedList, `length`, 0) > 0 && (
                <img
                  src="/images/building-illustration.svg"
                  className="img-fluid"
                />
              )}
              {totalCount > 10 ? (
                <PaginationPage
                  totalCount={totalCount}
                  limit={limit}
                  pageNumber={page_no}
                  handleChangePagination={handleChangePagination}
                  handleChangeLimit={handleChangeLimit}
                  // showLimit={"false"}
                />
              ) : (
                <p className="show-rows-count mt-3 d-flex">
                  Total Count:&nbsp;&nbsp;{" "}
                  <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                </p>
              )}
            </div> */}
            <DeleteModal
              isOpen={isDelete}
              handleModal={handleDelete}
              handleSubmit={handleDeleteFunction}
              deleteValue={deleteValue}
            />
          </div>
        </>
      )}
    </Layout>
  );
};

export default VendorsLocations;
